import { useGeneralStore } from "@/store/modules/general";

export const getActualLocationUser = () => {
    const store = useGeneralStore();

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
            store.latitude = position.coords.latitude;
            store.longitude = position.coords.longitude;
            store.zoom = 5;
        }, (error) => {
            console.log("Error getting location: " + error.message);
        }
        );
    }
}